import RadioCardItem from '@/components/molecules/RadioCardItem';
import * as S from './styles';
import Text from '@/components/atoms/Text';
import Avatar from '@/components/atoms/Avatar';
import { PlataformaStreaming } from '@/types/plataformaStreaming';

interface BotaoEscolherPlataformaProps {
  $onClick: () => void;
  $plataforma: PlataformaStreaming;
  $plataformaSelecionada: string;
}

export default function BotaoEscolherPlataforma(
  props: BotaoEscolherPlataformaProps,
) {
  const { $onClick, $plataforma, $plataformaSelecionada } = props;

  const plataformaImagem =
    $plataforma.logoArquivo?.urlx1 ||
    $plataforma.logoArquivo?.urlx2 ||
    $plataforma.logoArquivo?.urlx3;

  return (
    <S.ContainerBotao onClick={$onClick}>
      <RadioCardItem
        $size={2}
        $variant="outline"
        $color="neutral"
        $highContrast={false}
        $state={
          $plataformaSelecionada === $plataforma.plataformaStreamingID
            ? 'checked'
            : 'default'
        }
        $useRadioIcon
        style={{
          alignItems: 'center',
        }}
        $iconPosition="end"
      >
        <S.ContainerInformacoesAssinatura>
          <Avatar
            $size={3}
            $color="neutral"
            $image={plataformaImagem}
            $shape="square"
            $variant="solid"
            $imageProps={{
              objectFit: 'contain',
            }}
            $preencherFundo={false}
          />
          <Text
            $size={2}
            $color="neutral"
            $weight="medium"
            $align="left"
            $highContrast={true}
            $text={$plataforma.nome}
          />
        </S.ContainerInformacoesAssinatura>
      </RadioCardItem>
    </S.ContainerBotao>
  );
}
